export const reasonList = [
  {
    label: 'Overcome Travel Restrictions',
    description: "Reach researchers who can't travel due to visa issues or detention fears.",
  },
  {
    label: 'Expand Global Reach',
    description: 'Connect with scientists from every continent without geographical limitations.',
  },
  {
    label: 'Generate Additional Revenue',
    description: 'Create new income streams through on-demand access.',
  },
  {
    label: 'Preserve Knowledge',
    description: 'Create a permanent archive of presentations for future reference and research.',
  },
  {
    label: 'Increase Accessibility',
    description: 'Accommodate researchers with disabilities or mobility constraints.',
  },
  {
    label: 'Reduce Carbon Footprint',
    description: 'Support sustainability goals by reducing travel-related emissions.',
  },
  {
    label: 'Enable Flexible Scheduling',
    description: 'Allow attendees to view sessions across different time zones at their convenience.',
  },
  {
    label: 'Boost Citation Potential',
    description: 'Wider audience exposure can lead to increased citations and research impact.',
  },
  {
    label: 'Support Junior Researchers',
    description: 'Help early-career scientists with limited travel budgets access cutting-edge research.',
  },
  {
    label: 'Disaster-Proof Events',
    description: 'Ensure conferences continue even during emergencies or unexpected restrictions.',
  },
  {
    label: 'Facilitate Collaboration',
    description: 'Connect researchers who might never meet in person for future partnerships.',
  },
  {
    label: 'Enhance Q&A Sessions',
    description: 'Include virtual questions and broader audience participation.',
  },
  {
    label: 'Support Developing Countries',
    description: 'Remove financial barriers for researchers from lower-income regions.',
  },
  {
    label: 'Create Searchable Content',
    description: 'Enable participants to quickly find specific topics or presentations.',
  },
  {
    label: 'Build Society Brand',
    description: 'Establish your organization as a forward-thinking leader in scientific communication.',
  },
  {
    label: 'Quality Assurance',
    description: 'Professional recording ensures high-quality preservation of presentations.',
  },
  {
    label: 'Multi-language Support',
    description: 'Add subtitles or translations to reach non-native speakers.',
  },
  {
    label: 'Detailed Analytics',
    description: 'Track engagement and identify most popular sessions for future planning.',
  },
  {
    label: 'Backup Insurance',
    description: 'Protect against technical failures or unexpected cancellations.',
  },
  {
    label: 'Year-round Access',
    description: 'Extend the conference value beyond the event dates.',
  },
  {
    label: 'Future-Proof Investment',
    description: 'Build a digital asset that continues generating value for years.',
  },
];
